<mat-form-field
  class="w-100"
  appearance="outline"
  (click)="inputFastAutoUsers.select()"
>
  <mat-label (click)="inputFastAutoUsers.select()">
    {{ placeholder }}
  </mat-label>
  <input
    #inputFastAutoUsers
    matInput
    #triggerUsers="matAutocompleteTrigger"
    [formControl]="control"
    [matAutocomplete]="usersAutocomplete"
    [type]="inputType"
    (keydown)="onKeyDown($event)"
    (click)="inputFastAutoUsers.select()"
    (blur)="blur.emit($event)"
    [readonly]="readonly"
    (keyup)="enterSearch($event)"
    name="fast-autcomplete"
    autocomplete="off"
  />
  <p-button
    matSuffix
    *ngIf="!readonly && !control.hasError('isEmptyValue') && controlIsEnabled"
    pRipple
    [icon]="getBtnIcon()"
    class="mb-1 p-button-sm"
    [severity]="getBtnSeverity()"
    text
    rounded
    (click)="getBtnAction()"
  ></p-button>
</mat-form-field>
<small class="p-error" *ngIf="control.invalid && control.touched">
  {{ messages[getKey()] }}
</small>
<mat-autocomplete
  #usersAutocomplete="matAutocomplete"
  [displayWith]="displayWithEntityFn"
  (optionActivated)="onOptionActivated($event)"
>
  <!-- <ng-container
    *ngIf="
      control.value &&
      !control.hasError('isEmptyValue') &&
      stateSearch &&
      !valueControlStrChange
    "
  > -->
  <!-- <mat-option disabled *ngIf="isLoading" class="is-loading">
      <div class="flex justify-content-center align-items-center width-100">
        <span>Carregando...</span>
        <p-progressSpinner
          [style]="{ width: '50px', height: '50px' }"
        ></p-progressSpinner>
      </div>
    </mat-option> -->
  <mat-option disabled *ngIf="noResults">
    {{
      control.value
        ? 'Não encontramos nada com ' + control.value
        : 'Nenhum resultado disponível!'
    }}
  </mat-option>
  <ng-container *ngIf="!notShowOptions && !noResults">
    <mat-option
      #option
      (click)="confirmSelection(entity)"
      *ngFor="let entity of filteredEntities"
      [value]="entity"
    >
      {{ displayWithEntityFn(entity) }}
    </mat-option>
  </ng-container>
  <!-- <mat-option *ngIf="actionState">
      <div
        (click)="openDialogAddEntity ? openDialogAddEntity() : openDialogFast()"
        style="display: flex; align-items: center; color:#666;"
      >
        <i class="mdi mdi-plus"></i>
        Adicionar agora
      </div>
    </mat-option> -->
  <!-- </ng-container> -->
</mat-autocomplete>
